import React from 'react';
import {Link} from 'react-router-dom';
import {useTenant} from '../App';
import usePageTitle from '../hooks/usePageTitle';

export default function Applied() {
  const tenant = useTenant();
  usePageTitle('Application Submitted');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center max-w-md fade-in">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Application Submitted</h1>
        <p className="text-gray-500 mb-2">Thank you for applying! {tenant.name} will review your application and get back to you.</p>
        <p className="text-gray-400 text-sm mb-8">Check your email for a link to track your application status.</p>
        <div className="flex flex-col gap-3">
          <Link to="/" className="text-teal-600 hover:text-teal-800 font-medium focus:outline-none focus:underline">← View more positions</Link>
          <Link to="/check-status" className="text-sm text-gray-500 hover:text-gray-700 focus:outline-none focus:underline">Already applied? Check your status</Link>
        </div>
      </div>
    </div>
  );
}
